import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
//import './FT.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'
import './FT.css';


const modeloDatos = {
    recetaID: 0,
    empresaID: 1,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: ''
}
const modeloDatosP = {
    pacienteID: 0,
    empresaid: 0
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , tipoOrden: 0
    , seguroID: 0
    , nombreSeguro: ''
    , poliza: ''
    , centroID: 0
    , diagnostico: ''
    , diagnosticoClinico: ''
    , direccion: ''
    , tratamientoID: 0
    , nombreTratamiento: ''
    , resultado: ''
    , toxicos: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''


}

const ImpresionReporteAtendido = () => {
    let { Pedido } = useParams();

    const [Listado, SetListado] = useState([]);
    const [Record, SetRecord] = useState(modeloDatos);
    const [Recordp, SetRecordP] = useState(modeloDatosP);
    const [VerImprimir, SetVerImprimir] = useState(false);


    const obtenerDatos = async () => {
        let response = await fetch(Api + "Pacientes/ListaReporteAtendido");
        if (response.ok) {
            let data = await response.json()
            SetListado(data);
            obtenerDatosp(data.pacienteID)
            ObtenerReceta(data.recordPacienteID)
        }
    }
        const obtenerDatosp = async (d) => {
            let response = await fetch(Api + "Pacientes/GetGastro/"+d);
        if (response.ok) {
            let data = await response.json()
            SetRecordP(data);
        }
    }



    const ObtenerReceta = async (d) => {
        let response = await fetch(Api + "Pacientes/Recetas/" + d);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
        }
    }
    useEffect(() => {
       obtenerDatos()
        
    }, [])

    const Imprimir = () => {
        SetVerImprimir(true)
        window.print();

    }

    return (
        <>
            <div onClick={() => Imprimir()}  >
               
          
                    
           
                           
             
                <div class="containerPr" >
                    {/*onClick={() => Imprimir()} >*/}
                    <div>
                        <div class="hoja-timbrada">
                            <div class="header">
                               
                                <img src="/imagen/logogastro.png" alt="Logo Central" class="logo-center" />
                                <h1 style={{color: "#2c7a7b", fontSize: "1.5rem",  marginBottom: "0.5rem"} }><b>Dra. Ana Ydalina Pichardo</b></h1>
                                <p class="subtitle">Medicina Interna | Gastroenterología | Endoscopia Digestiva | Balón Gástrico</p>
                                <p class="subtitle">Reporte de atencion a paciente del</p>
                                <p class="subtitle">20/03/2024 </p>


                                <div style={{  marginLeft: "40px" }}>



                                    <table className="table">
                                        <tr>
                                            <th>Paciente </th>
                                            <th>Telefono </th>
                                            <th>Seguro </th>
                                            <th>Poliza </th>
                                            <th>Historia </th>
                                          
                                        </tr>
                    {Listado.map(x => (
                        <tr>
                        <td>{x.nombres}</td>
                        <td>{x.telefono}</td>
                        <td>{x.nombreSeguro}</td>
                        <td>{x.poliza}</td>
                        <td>{x.historiaClinica}</td>
                      
                        </tr>
                            
                 
                    ))}

                  </table>
                                </div>
                            

                              
                            </div>
                        </div>
                    </div>
                     
            </div>
            </div>
        </>
        )

}
export default ImpresionReporteAtendido;